import React, { memo } from 'react'

import { Button, Icon, Textarea, ImageAdd, ArrowUp } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, bool, func, number, object, shape, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'

import References from './Components/References/References'

const PLACEHOLDER = 'Describe the object and view (e.g., electric sports car, front 3/4 view)'
const uploadIcon = <Icon svgComponent={ImageAdd} size={iconSize} color="dark" notSpaced />
const sendIcon = <Icon svgComponent={ArrowUp} size={iconSize} color="light" notSpaced />

function Composer({
  prompt,
  attachments,
  tags,
  fileInputRef,
  isSendDisabled,
  isUploadDisabled,
  onPromptChange,
  onTagClick,
  onUploadClick,
  onRemoveAttachment,
  onFilesChange,
  onSend,
}) {
  const handleKeyDown = (event) => {
    // Enter sends; Shift+Enter inserts a newline.
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      if (!isSendDisabled) {
        onSend()
      }
    }
  }

  return (
    <div className="image-assistant-panel__composer">
      <div className="image-assistant-panel__composer-card">
        {attachments.length > 0 && (
          <References
            attachments={attachments}
            tags={tags}
            onRemoveAttachment={onRemoveAttachment}
            onTagClick={onTagClick}
          />
        )}
        <div className="image-assistant-panel__composer-input">
          <Textarea
            id="ai-create-prompt"
            rows={1}
            isNotResizable
            inputClassName="image-assistant-panel__prompt-field-wrap"
            className="image-assistant-panel__prompt-field cgt-button-text-md"
            placeholder={PLACEHOLDER}
            value={prompt}
            onChange={onPromptChange}
            onKeyDown={handleKeyDown}
          />
          <div className="image-assistant-panel__composer-actions">
            <Button
              variant="only-icon"
              actionType="button"
              customClass="image-assistant-panel__upload-button"
              icon={uploadIcon}
              aria-label="Upload image"
              onClick={onUploadClick}
              disabled={isUploadDisabled}
            />
            <Button
              variant="only-icon"
              actionType="button"
              customClass="image-assistant-panel__send-button"
              icon={sendIcon}
              aria-label="Send prompt"
              onClick={onSend}
              disabled={isSendDisabled}
            />
          </div>
        </div>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        multiple
        className="image-assistant-panel__file-input"
        onChange={onFilesChange}
        aria-hidden
        tabIndex={-1}
      />
    </div>
  )
}

Composer.propTypes = {
  prompt: string.isRequired,
  attachments: arrayOf(shape({ id: number.isRequired, url: string.isRequired })).isRequired,
  tags: arrayOf(string).isRequired,
  fileInputRef: shape({ current: object }).isRequired,
  isSendDisabled: bool.isRequired,
  isUploadDisabled: bool.isRequired,
  onPromptChange: func.isRequired,
  onTagClick: func.isRequired,
  onUploadClick: func.isRequired,
  onRemoveAttachment: func.isRequired,
  onFilesChange: func.isRequired,
  onSend: func.isRequired,
}

export default memo(Composer)
